const labelModel = {
  labelCreationDate: null,
  labelLink: '',
  packageStatus: 'Pending',
  trackingID: '',
};

const returnModel = {
  returnInitiationDate: null,
  returnOrderId: '',
  returnInitiation: {
    shippingLabels: [],
    returnSource: 'MyAccount',
    devices: [],
    returnMethod: '',
  },
  returnOrderStatus: 'Initiated',
};

/*
DSM Response from Label
{
  "labelLink": "https://customer.dev.xfinity.com/returns/label?trackingId=1Z1R65679097507083",
  "returnOrderId": "41846514352518",
  "trackingID": "1Z1R65679097507083"
} */

export const newLabel = dsmResponse => Object.assign({}, labelModel, {
  labelLink: dsmResponse.labelLink,
  trackingID: dsmResponse.trackingID,
});

/*
DSM Response from Order
{
  "labelLink": "https://customer.dev.xfinity.com/returns/label?trackingId=1Z1R65679010524404",
  "returnOrderId": "41846514352518",
  "trackingID": "1Z1R65679010524404"
} */

export const newReturn = (dsmResponse, devices, returnMethod) => Object.assign({}, returnModel, {
  returnOrderId: dsmResponse.returnOrderId,
  trackingId: dsmResponse.trackingID,
  returnInitiation: Object.assign({}, returnModel.returnInitiation, {
    shippingLabels: dsmResponse.labelLink ? [newLabel(dsmResponse)] : [],
    devices,
    returnMethod,
  }),
});
